/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Pick_FileInputs */

const cs_social_export_pick_file = /** @type {(inputs: Social_Export_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat obrázek nebo video`)
};

const en_social_export_pick_file = /** @type {(inputs: Social_Export_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose image or video`)
};

/**
* | output |
* | --- |
* | "Choose image or video" |
*
* @param {Social_Export_Pick_FileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_pick_file = /** @type {((inputs?: Social_Export_Pick_FileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Pick_FileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_pick_file(inputs)
	return cs_social_export_pick_file(inputs)
});